import Config from '../../../config/Config';
import getLogger from '../../../utils/logger';

const getIframeContainer = () => document.getElementById('CoreIFrame');
const getRcoreContainer = () => document.getElementById('rcore-page-content');
const postMessage = (
  action,
  data,
  forwardMessage = false,
  sourceElementId = null,
  opensSlideout = false,
  hideCore = false
) => {
  const fromRcoreRoute = window.location.pathname.toLowerCase().indexOf('/c/') < 0;
  if (!forwardMessage && !opensSlideout && !hideCore) {
    toggleVisibility(true, fromRcoreRoute);
  }
  const iFrameContainer = getIframeContainer();
  let message = null;
  if (forwardMessage) {
    message = data;
  } else if (sourceElementId) {
    message = { pillarKey: 'RCORE', action, parameters: data, elementId: sourceElementId };
  } else {
    message = { pillarKey: 'RCORE', action, parameters: data };
  }
  if (iFrameContainer !== null && iFrameContainer !== undefined) {
    iFrameContainer.contentWindow.postMessage(message, '*');
  }
};
const setIframe = (url, title) => {
  const isRcoreRoute = window.location.pathname.toLowerCase().indexOf('/c/') < 0;
  toggleVisibility(!isRcoreRoute);
  const iFrameContainer = getIframeContainer();
  iFrameContainer.src = `${Config.domain + url}${
    url.indexOf('?') !== -1 ? '&' : '?'
  }${coreRedirectionQS}=1`;
  if (title && title.length > 0) iFrameContainer.title = title;
};
const setCoreframeTitle = (title) => {
  const iFrameContainer = getIframeContainer();
  if (iFrameContainer !== null && iFrameContainer !== undefined) {
    iFrameContainer.title = title;
  }
};
const toggleVisibility = (visible, fromRcoreRoute) => {
  if (visible) {
    if (fromRcoreRoute) showIframe(fromRcoreRoute);
    else {
      setTimeout(() => {
        showIframe(fromRcoreRoute);
      }, 500);
    }
  } else {
    hideIframe();
  }
};
const showIframe = (fromRcoreRoute) => {
  const iFrameContainer = getIframeContainer();
  if (iFrameContainer !== null && iFrameContainer !== undefined) {
    iFrameContainer.style.visibility = 'visible';
    iFrameContainer.style.opacity = '1';
    iFrameContainer.style.position = null;
    iFrameContainer.style.zIndex = fromRcoreRoute ? '2' : 'inherit';
    iFrameContainer.removeAttribute('aria-hidden');
  }
  const rcoreContainer = getRcoreContainer();
  if (rcoreContainer !== null && rcoreContainer !== undefined) {
    rcoreContainer.style.overflow = fromRcoreRoute ? 'auto' : null;
    rcoreContainer.style.position = fromRcoreRoute ? 'relative' : null;
    rcoreContainer.style.height = fromRcoreRoute ? '100%' : null;
    rcoreContainer.style.display = fromRcoreRoute ? 'block' : 'none';
  }
};
const hideIframe = () => {
  const iFrameContainer = getIframeContainer();
  if (iFrameContainer !== null && iFrameContainer !== undefined) {
    iFrameContainer.style.visibility = 'hidden';
    iFrameContainer.style.opacity = '0';
    iFrameContainer.style.position = 'absolute';
    iFrameContainer.style.zIndex = -2;
    iFrameContainer.setAttribute('aria-hidden', 'true');
  }
  const rcoreContainer = getRcoreContainer();
  if (rcoreContainer !== null && rcoreContainer !== undefined) {
    rcoreContainer.style.overflow = 'auto';
    rcoreContainer.style.position = 'relative';
    rcoreContainer.style.height = '100%';
  }
};
const coreRedirectionQS = 'rc';
const removeIframeClickListeners = () => {
  const iFrameContainer = getIframeContainer();
  addRemoveListenerForFrames(iFrameContainer, 'REMOVE', null);
};
const addIframeClickListeners = (callback) => {
  const iFrameContainer = getIframeContainer();
  addRemoveListenerForFrames(iFrameContainer, 'ADD', callback);
};
const addRemoveListenerForFrames = (parentContainer, action, callback = null) => {
  const iFrameContainer = parentContainer;
  if (iFrameContainer) {
    if (
      canAccessIFrame(iFrameContainer) &&
      iFrameContainer.contentWindow &&
      iFrameContainer.contentWindow.document &&
      iFrameContainer.contentWindow.document.body
    ) {
      iFrameContainer.contentWindow.document.onclick = action === 'ADD' ? callback : null;
      iFrameContainer.contentWindow.document.onmousedown = action === 'ADD' ? callback : null;
      iFrameContainer.contentWindow.document.onkeydown = action === 'ADD' ? callback : null;
      const frames = parentContainer.contentDocument.getElementsByTagName('iframe');
      if (frames.length > 0) {
        for (let i = 0; i < frames.length; i++) {
          addRemoveListenerForFrames(frames[i], action, callback);
        }
      }
    } else {
      addListenerForCrossOriginFrame(parentContainer, action, callback);
    }
  }
};
const addListenerForCrossOriginFrame = (frameContainer, action, callback = null) => {
  if (action === 'ADD' && callback) {
    const myConfObj = {
      iframeMouseOver: false
    };
    window.addEventListener('blur', function _blurHandler() {
      if (myConfObj.iframeMouseOver) {
        callback();
      }
      window.removeEventListener('blur', _blurHandler);
    });
    frameContainer.addEventListener('mouseover', function _mouseOverHandler() {
      myConfObj.iframeMouseOver = true;
      frameContainer.removeEventListener('mouseover', _mouseOverHandler);
    });
    frameContainer.addEventListener('mouseout', function _mouseOutHandler() {
      myConfObj.iframeMouseOver = true;
      frameContainer.removeEventListener('mouseout', _mouseOutHandler);
    });
  }
};
const canAccessIFrame = (iframe) => {
  let html = null;
  try {
    const doc = iframe.contentDocument || iframe.contentWindow.document;
    html = doc.body.innerHTML;
  } catch (err) {
    getLogger().warn(`Its a cross-origin frame!! id:${iframe.id}, src: ${iframe.src}`);
  }
  return html !== null;
};
export {
  postMessage,
  toggleVisibility,
  setIframe,
  setCoreframeTitle,
  getIframeContainer,
  removeIframeClickListeners,
  addIframeClickListeners,
  addListenerForCrossOriginFrame
};
